<!-- desktop template -->
<div *appIsDesktop>
  <div class="paper-container">
    <ds-paper elevation="elevation_none" borderRadius="radius_XS" outline="outlined">
      <app-accounts-filter-form (resetSort)="resetSortIndicator($event)"></app-accounts-filter-form>
      <div class="accounts content" id="accountsListContainer">
        @if (!totalRecords && !loading && !loadingPartial) {
          <div id="emptyAccountList" class="no-results">
          {{appStrings.noEntriesFound}} </div>
        }
        @if (loading) {
          <div id="loadingContainer" class="overlay full">
            <p class="text-center">{{ appStrings.pleaseWait }}</p>
            <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
          </div>
        }
        <div [hidden]="!totalRecords">
          <div class="table-container">
            <ds-table id="accountsTable" class="accountsTable" mat-table [dataSource]="recordList$"
              [displayedColumns]="displayedColumns" (matSortChange)="sortData($event)" matSort>
              <ng-container matColumnDef="icon">
                <th mat-header-cell *matHeaderCellDef id="icon_header"></th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" [id]="'icons_'+i"
                  [ngClass]="{'ln-inactive': element.lnStatus === inactiveLnStatus}">
                  <ds-icon class="round-icon no-pointer-cursor" [ngClass]="element.recordType === 1 ? 'blue' : 'green'"
                    [icon]="iconMapping[element.recordType]" iconStyle="material-icons-outlined"
                    [id]="iconMapping[element.recordType]+'_'+i">
                  </ds-icon>
                </td>
              </ng-container>

              <ng-container matColumnDef="accountManagerName">
                <th [hidden]="!isAdmin" mat-header-cell *matHeaderCellDef id="accountManagerName_header">
                  {{ appStrings.quoteDetails_AccountManager }}
                </th>
                <td [hidden]="!isAdmin" mat-cell *matCellDef="let element; let i = dataIndex"
                  [id]="appStrings.quoteDetails_AccountManager+'_'+i"
                  [ngClass]="{'ln-inactive': element.lnStatus === inactiveLnStatus}">
                  {{ element.accountManagerName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="name1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="name1_header"> {{appStrings.accounts_labelName}} 1</th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" class="customer-name"
                  [id]="appStrings.accounts_labelName+1+'_'+i"
                [ngClass]="{'ln-inactive': element.lnStatus === inactiveLnStatus}"> {{element.name1}} </td>
              </ng-container>

              <ng-container matColumnDef="name2">
                <th mat-header-cell *matHeaderCellDef id="name2_header"> {{appStrings.accounts_labelName}} 2</th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" class="customer-name"
                  [id]="appStrings.accounts_labelName+2+'_'+i"
                [ngClass]="{'ln-inactive': element.lnStatus === inactiveLnStatus}"> {{element.name2}} </td>
              </ng-container>

              <ng-container matColumnDef="childName1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="childName1_header"> {{appStrings.accounts_labelChildName}}</th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" class="customer-name"
                  [id]="appStrings.accounts_labelChildName+'_'+i"
                [ngClass]="{'ln-inactive': element.lnStatus === inactiveLnStatus}"> {{element.childName1}} </td>
              </ng-container>

              <ng-container matColumnDef="priceMatrix">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="priceMatrix_header"> {{appStrings.accounts_priceMatrix}}</th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" class="price-matrix"
                  [id]="appStrings.accounts_priceMatrix+'_'+i"
                [ngClass]="{'ln-inactive': element.lnStatus === inactiveLnStatus}"> {{element.priceMatrix}} </td>
              </ng-container>

              <ng-container matColumnDef="business">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="business_header"> {{appStrings.accounts_labelBusiness}} </th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" [id]="appStrings.accounts_labelBusiness+'_'+i"
                  [ngClass]="{'ln-inactive': element.lnStatus === inactiveLnStatus}">
                  {{element.businessPartnerNo}}
                </td>
              </ng-container>

              <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="address_header"> {{appStrings.accounts_labelAddress}} </th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" [id]="appStrings.accounts_labelAddress+'_'+i"
                  [ngClass]="{'ln-inactive': element.lnStatus === inactiveLnStatus}">
                  {{element.address}}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="actions-column-header" id="actions_header"></th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" [id]="'actions_'+i" class="actions-column"
                  (click)="$event.stopPropagation()">
                  <div class="actions-row">
                    @if (element.leadStatus===1) {
                      <div class="validate-actions">
                        @if (element.recordType===2 && element.canEdit) {
                          <ds-button type="secondary" size="medium" variant="label-only"
                            [id]="'validate_'+i" [isDisabled]="!isOnline"
                            class="actions-button" (onClick)="openAccountsEmailPop(element, $event)"
                            [label]="appStrings.accounts_validate">
                          </ds-button>
                        }
                        @if (element.recordType===3 && element.canEdit) {
                          <ds-button type="secondary" size="medium" variant="label-only" [id]="'validate_'+i" [isDisabled]="!isOnline"
                            class="actions-button" (onClick)="openDeliveryEmailPop(element, $event)"
                            [label]="appStrings.accounts_validate">
                          </ds-button>
                        }
                      </div>
                    }
                    @if (element.leadStatus===2 && (element.recordType===2 || element.recordType===3) && (isAdmin || isOwnLead(element))) {
                      <ds-button type="secondary" size="medium" variant="label-only"
                        [id]="'merge_'+i" [isDisabled]="!isOnline"
                        class="actions-button" (onClick)="openMergeLeadModal(element, $event)"
                        [label]="appStrings.leads_mergeButton">
                      </ds-button>
                      @if (isAdmin) {
                        <ds-button type="secondary" size="medium" variant="label-only"
                          [id]="'reject_'+i" [isDisabled]="!isOnline"
                          class="actions-button" (onClick)="openRejectLeadModal(element, $event)"
                          [label]="appStrings.button_reject">
                        </ds-button>
                      }
                    }
                    @if (displayNewQuoteButton(element)) {
                      <ds-tooltip [tooltip_message]="appStrings.button_newQuote" tooltip_position="below">
                        <ds-button type="tertiary" size="medium" variant="icon-only" class="actions-button"
                          (onClick)="openNewQuote(element, $event)" [id]="'newQuote_'+i" icon="post_add" iconStyle="material-icons-outlined">
                        </ds-button>
                      </ds-tooltip>
                    }
                    @if (element.recordType === 1) {
                      <ds-tooltip [tooltip_message]="appStrings.menu_B2BUsers" tooltip_position="below">
                        <ds-button type="tertiary" size="medium" variant="icon-only" class="actions-button"
                          [id]="'b2bUsers_'+i" icon="shopping_cart" iconStyle="material-icons-outlined" (onClick)="navigateToB2BUsers(element, $event)">
                        </ds-button>
                      </ds-tooltip>
                    }
                    <ds-tooltip [tooltip_message]="appStrings.products_showMore" tooltip_position="below">
                      <ds-button type="tertiary" size="medium" variant="icon-only" class="actions-button"
                        [id]="'viewDetails_'+i" icon="visibility" iconStyle="material-icons-outlined" (onClick)="viewAccountDetails(element)">
                      </ds-button>
                    </ds-tooltip>
                  </div>
                </td>
              </ng-container>
            </ds-table>
          </div>
          @if (totalRecords > 0) {
            <div class="pagination-container" id="pagination-container">
              <div class="page-count" id="page-count">
                <b>{{ pageOffset + 1 }} - {{ pageOffset + currentPageItemCount }}</b> {{appStrings.pagination_of}} <b>{{ totalRecords }}</b>
              </div>
              <div class="pagination" id="pagination">
                @if (showPagination) {
                  <ds-pagination
                    id="ds-pagination"
                    [totalPages]="totalPages"
                    paginationDisplay="large"
                    buttonTypes="nextPrevFirstLast"
                    (pageChanged)="loadPage($event)"
                  ></ds-pagination>
                }
              </div>
            </div>
          }
        </div>
        @if (loadingPartial) {
          <div id="loadingPartialResults" class="searching-row row-loading">
            <span id="hourglassLoading" class="crm-industrial-font icon-hourglass"></span>{{appStrings.loading_stillSearching}}
          </div>
        }
      </div>
    </ds-paper>
  </div>
</div>

<!-- mobile template -->
<div *appIsMobile class="mobile">
  @if (loading) {
    <div class="overlay full" id="accounts-mobile-loadingSpinner">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }

  <app-accounts-filter-form (resetSort)="resetSortIndicator($event)"></app-accounts-filter-form>

  @for (element of (recordList$ | async); track element; let i = $index) {
    <mat-expansion-panel class="mobile-card two-columns tall blue-border"
      [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title id="account-card-header-container-{{i}}" class="card-header-container">
          <span class="card-header">
            <span class="icon-and-title">
              <ds-icon
                class="round-icon"
              [ngClass]="{
                'blue': element.recordType === 1 && element.lnStatus !== inactiveLnStatus,
                'green': element.recordType !== 1 && element.lnStatus !== inactiveLnStatus,
                'red': element.lnStatus === inactiveLnStatus
              }"
                [icon]="iconMapping[element.recordType]"
                iconStyle="material-icons-outlined"
                [id]="iconMapping[element.recordType]+'_mobile_'+i">
              </ds-icon>
              <span class="title-column">
                <span id="account-card-title_{{i}}" class="title" [ngClass]="{'ln-inactive': element.lnStatus === inactiveLnStatus}">
                  {{ element.name1 }}
                </span>
                <span id="account-card-subtitle_{{i}}" class="subtitle">
                  {{ element.name2 }}
                </span>
              </span>
            </span>
          </span>
          <div class="collapsed-content">
            <ds-divider></ds-divider>
            <div class="collapsed-address">
              <typography variant="body-2" weight="regular">{{ element.address ?? '—' }}</typography>
            </div>
            <div class="mobile-card-actions">
              @if (element.leadStatus===1) {
                <div class="validate-actions">
                  @if (element.recordType===2 && element.canEdit) {
                    <ds-button type="primary" size="medium" variant="label-only"
                      [id]="'validate_mobile_'+i" [isDisabled]="!isOnline"
                      (onClick)="openAccountsEmailPop(element, $event)"
                      [label]="appStrings.accounts_validate">
                    </ds-button>
                  }
                  @if (element.recordType===3 && element.canEdit) {
                    <ds-button type="primary" size="medium" variant="label-only"
                      [id]="'validate_mobile_'+i" [isDisabled]="!isOnline"
                      (onClick)="openDeliveryEmailPop(element, $event)"
                      [label]="appStrings.accounts_validate">
                    </ds-button>
                  }
                </div>
              }
              <div class="lead-actions-row">
                @if (displayNewQuoteButton(element)) {
                  <ds-button type="secondary" size="medium" variant="label-only"
                    (onClick)="openNewQuote(element, $event)"
                    [label]="appStrings.button_newQuote"
                    [id]="'newQuote_mobile_'+i">
                  </ds-button>
                }
                @if (element.recordType === 1) {
                  <ds-button type="secondary" size="medium" variant="label-only"
                    (onClick)="navigateToB2BUsers(element, $event)"
                    [label]="appStrings.menu_B2BUsers"
                    [id]="'b2bUsers_mobile_'+i">
                  </ds-button>
                }
                <ds-button type="secondary" size="medium" variant="label-only"
                  [id]="'viewDetails_mobile_'+i"
                  [label]="appStrings.products_showMore"
                  (onClick)="viewAccountDetails(element)">
                </ds-button>
              </div>
              @if (element.leadStatus===2 && (element.recordType===2 || element.recordType===3) && (isAdmin || isOwnLead(element))) {
                <div class="lead-actions-row">
                  <ds-button type="primary" size="medium" variant="label-only"
                    [id]="'merge_mobile_'+i" [isDisabled]="!isOnline"
                    (onClick)="openMergeLeadModal(element, $event)"
                    [label]="appStrings.leads_mergeButton">
                  </ds-button>
                  @if (isAdmin) {
                    <ds-button type="primary" size="medium" variant="label-only"
                      [id]="'reject_mobile_'+i" [isDisabled]="!isOnline"
                      (onClick)="openRejectLeadModal(element, $event)"
                      [label]="appStrings.button_reject">
                    </ds-button>
                  }
                </div>
              }
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expanded-content">
        <ds-divider></ds-divider>
        <div class="content">
          <div class="row">
            <div class="column full-width">
              <typography [id]="'address_label_'+i" class="label" variant="caption-2" weight="regular">
                {{ appStrings.accounts_labelAddress }}
              </typography>
              <typography [id]="'address_'+i" variant="body-2" weight="medium">
                {{ element.address ?? '-' }}
              </typography>
            </div>
          </div>
          <div class="row">
            @if (isAdmin) {
              <div class="column">
                <typography [id]="'accountManager_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{ appStrings.quoteDetails_AccountManager }}
                </typography>
                <typography [id]="'accountManager_'+i" variant="body-2" weight="medium">
                  {{ element.accountManagerName ?? '-' }}
                </typography>
              </div>
            }
            <div class="column" [ngClass]="{'one-forth': isAdmin}">
              <typography [id]="'priceMatrix_label_'+i" class="label" variant="caption-2" weight="regular">
                {{ appStrings.accounts_priceMatrix }}
              </typography>
              <typography [id]="'priceMatrix_'+i" variant="body-2" weight="medium">
                {{ element.priceMatrix ?? '-' }}
              </typography>
            </div>
            <div class="column" [ngClass]="{'one-forth': isAdmin}">
              <typography [id]="'business_label_'+i" class="label" variant="caption-2" weight="regular">
                {{ appStrings.accounts_labelBusiness }}
              </typography>
              <typography [id]="'business_'+i" variant="body-2" weight="medium">
                {{ element.businessPartnerNo ?? '-' }}
              </typography>
            </div>
          </div>
          <div class="row">
            <div class="column" [ngClass]="{'one-forth': isAdmin}">
              <typography [id]="'type_label_'+i" class="label" variant="caption-2" weight="regular">
                {{ appStrings.accounts_labelType }}
              </typography>
              <typography [id]="'type_'+i" variant="body-2" weight="medium">
                {{ element.recordTypeLabel ?? '-' }}
              </typography>
            </div>
            <div class="column">
              <typography [id]="'childName_label_'+i" class="label" variant="caption-2" weight="regular">
                {{ appStrings.accounts_labelChildName }}
              </typography>
              <typography [id]="'childName_'+i" variant="body-2" weight="medium">
                {{ element.childName1 ?? '-' }}
              </typography>
            </div>
          </div>
        </div>
        <div class="mobile-card-actions">
          @if (element.leadStatus===1) {
            <div class="validate-actions">
              @if (element.recordType===2 && element.canEdit) {
                <ds-button type="primary" size="medium" variant="label-only"
                  [id]="'validate_mobile_expanded_'+i" [isDisabled]="!isOnline"
                  (onClick)="openAccountsEmailPop(element, $event)"
                  [label]="appStrings.accounts_validate">
                </ds-button>
              }
              @if (element.recordType===3 && element.canEdit) {
                <ds-button type="primary" size="medium" variant="label-only"
                  [id]="'validate_mobile_expanded_'+i" [isDisabled]="!isOnline"
                  (onClick)="openDeliveryEmailPop(element, $event)"
                  [label]="appStrings.accounts_validate">
                </ds-button>
              }
            </div>
          }
          <div class="lead-actions-row">
            @if (displayNewQuoteButton(element)) {
              <ds-button type="secondary" size="medium" variant="label-only"
                (onClick)="openNewQuote(element, $event)"
                [label]="appStrings.button_newQuote"
                [id]="'newQuote_mobile_expanded_'+i">
              </ds-button>
            }
            @if (element.recordType === 1) {
              <ds-button type="secondary" size="medium" variant="label-only"
                (onClick)="navigateToB2BUsers(element, $event)"
                [label]="appStrings.menu_B2BUsers"
                [id]="'b2bUsers_mobile_expanded_'+i">
              </ds-button>
            }
            <ds-button type="secondary" size="medium" variant="label-only"
              [id]="'viewDetails_mobile_'+i"
              [label]="appStrings.products_showMore"
              (onClick)="viewAccountDetails(element)">
            </ds-button>
          </div>
          @if (element.leadStatus===2 && (element.recordType===2 || element.recordType===3)) {
            <div class="lead-actions-row">
              <ds-button type="primary" size="medium" variant="label-only"
                [id]="'merge_mobile_expanded_'+i" [isDisabled]="!isOnline"
                (onClick)="openMergeLeadModal(element, $event)"
                [label]="appStrings.leads_mergeButton">
              </ds-button>
              @if (isAdmin) {
                <ds-button type="primary" size="medium" variant="label-only"
                  [id]="'reject_mobile_expanded_'+i" [isDisabled]="!isOnline"
                  (onClick)="openRejectLeadModal(element, $event)"
                  [label]="appStrings.button_reject">
                </ds-button>
              }
            </div>
          }
        </div>
      </div>
    </mat-expansion-panel>
  }

  @if (loadingPartial) {
    <div id="loadingPartialResults_mobile" class="searching-row row-loading">
      <span id="hourglassLoading_mobile" class="crm-industrial-font icon-hourglass"></span>{{appStrings.loading_stillSearching}}
    </div>
  }
  @if (!loading && !loadingPartial && !totalRecords) {
    <div id="no-results-mobile" class="no-results">
      {{appStrings.noEntriesFound}}
    </div>
  }

  @if (totalRecords > 0) {
    <div class="pagination-container-mobile">
      <ds-paper elevation="elevation_none" borderRadius="radius_XS" outline="outlined"
        insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S">
        <div class="pagination">
          @if (showPagination) {
            <ds-pagination
              id="accounts-mobile-pagination"
              [totalPages]="totalPages"
              paginationDisplay="small"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="loadPage($event)"
            ></ds-pagination>
          }
        </div>
      </ds-paper>
    </div>
  }
</div>